define('app/views/defaultAnalytics/rooms',[], function () {
  return {
    requestPmsRoomTypeSelection: function (rateType, roomTypes) {
      if (app.data.dataLayerEvents) {
        dataLayer.push({
          ecommerce: {
            impressions: _.map(roomTypes, function (room, position) {
              return {
                name: room.PMSRateName, // Name or ID is required.
                id:
                  "Room-Room-Type-" +
                  rateType +
                  "-" +
                  (room.PMSRoomType && room.PMSRoomType.PMSRoomTypeId),
                category: room.PMSRoomType && room.PMSRoomType.PMSRoomTypeId,
                price: room.AverageRate,
                brand: room.Venue,
                quantity: _.isArray(room.DailyRate) && room.DailyRate.length,
                list: "Hotel Room Type Search Results",
                position: position,
              };
            }),
          },
        });
      }

      gtag("event", "view_item_list", {
        item_list_id: "Rooms-" + rateType,
        item_list_name: "Hotel Room Type Search Results For " + rateType,
        items: _.map(roomTypes, function (room, position) {
          return {
            item_id:
              "Room-Rate-" +
              rateType +
              "-" +
              (room.PMSRoomType && room.PMSRoomType.PMSRoomTypeId),
            item_name: room.PMSRateName,
            affiliation: app.localization.siteName,
            item_category: room.PMSRoomType && room.PMSRoomType.PMSRoomTypeId,
            index: position,
            price: +room.AverageRate,
            quantity: _.isArray(room.DailyRate) && room.DailyRate.length,
          };
        }),
      });
    },
    requestPmsRateSelection: function (
      pmsArrivalDate,
      pmsDepartureDate,
      pmsNumAdults,
      pmsNumYouth,
      pmsNumChildren,
      pmsNumJrChildren,
      pmsPromoCode,
      PMSRateType,
      dayGuest
    ) {
      if (app.data.dataLayerEvents) {
        dataLayer.push({
          ecommerce: {
            impressions: _.map(PMSRateType, function (rate, position) {
              return {
                name: rate.PMSRateTypeDesc, // Name or ID is required.
                id: "Room-" + rate.PMSRateTypeId,
                brand: rate.Venue,
                list: "Hotel Rate Type Search Results",
                position: position,
              };
            }),
          },
        });

        dataLayer.push({
          event: "RoomSearch",
          ArrivalDate: pmsArrivalDate,
          DepartureDate: pmsDepartureDate,
          NumAdults: pmsNumAdults,
          NumYouth: pmsNumYouth,
          NumChildren: pmsNumChildren,
          NumJrChildren: pmsNumJrChildren,
          PromoCode: pmsPromoCode,
        });
      }

      dataLayer.push({
        event: "view_item_list",
        ecommerce: {
          item_list_id: "Rates-" + pmsArrivalDate + "-" + pmsDepartureDate, // search params -arrival departure
          item_list_name:
            "Hotel Rate Type Search Results For " +
            pmsArrivalDate +
            "-" +
            pmsDepartureDate,
          items: _.map(PMSRateType, function (rate, position) {
            return {
              item_id: "Room-" + rate.PMSRateTypeId,
              item_name: rate.PMSRateTypeDesc,
              affiliation: app.localization.siteName,
              item_brand: rate.Venue,
              quantity: 1,
            };
          }),
        },
      });
    },
    requestGroupBooking: function (groupCode, blockInfo) {
      var blocks =
        (blockInfo &&
          blockInfo.Availabilities &&
          blockInfo.Availabilities.Blocks) ||
        [];
      if (blocks.length) {
        var uniqBlocks = {};
        _.each(blocks, function (block) {
          var blocksList = block.Block;
          _.each(blocksList, function (block) {
            if (block && block.RateType && !uniqBlocks[block.RateType]) {
              uniqBlocks[block.RateType] = block;
            }
          });
        });
        var uniqBlockValues = _.values(uniqBlocks);
        if (uniqBlockValues.length) {
          gtag("event", "view_item_list", {
            item_list_id: "Hotel Group Rate Type Search Results",
            item_list_name: "Hotel Group Rate Type Search Results",
            items: _.map(uniqBlockValues, function (block) {
              return {
                item_id: "Room-" + block.RateType,
                item_name: block.RateTypeDesc,
                affiliation: app.localization.storeName,
                item_brand: block.Venue,
                item_category: block.RateType,
                quantity: 1,
              };
            }),
          });
        }
      }
    },
    pmsRemoveSpecialService: function (folioBookingsRes, pmsFolioId, pmsFolioSpecialServiceId) {
      var folioBookings = folioBookingsRes && folioBookingsRes.WebFolioItem;
      console.log("pmsRemoveSpecialService", folioBookings, pmsFolioId, pmsFolioSpecialServiceId);
      if(folioBookings && folioBookings.length) {
        for(var i = 0; i < folioBookings.length; i++) {
          var folioBooking = folioBookings[i];
          if(folioBooking.Category == 'Hotel' && folioBooking.FolioId === pmsFolioId && folioBooking.specialServices && folioBooking.specialServices.length) {
            for(var j = 0; j < folioBooking.specialServices.length; j++) {
              var service = folioBooking.specialServices[j];
              if(service.PMSFolioSpecialServiceId === pmsFolioSpecialServiceId) {
                gtag("event", "remove_from_cart", {
                  currency: app.customization.currencyCode,
                  value: +service.PMSSpecialService.Price,
                  items: [
                    {
                      'item_id': service.PMSSpecialService.PMSItemId,
                      'item_name': service.PMSSpecialService.PMSSpecialServiceName,
                      'affiliation': app.localization.siteName,
                      'item_category': service.PMSSpecialService.PMSSpecialServiceName,
                      'price': +service.PMSSpecialService.Price,
                      'quantity': service.Qty
                    }
                  ]
                });
                return;
              }
            }
          }
        }
      }
    },
    specialServiceCatClick: function (specialServices, category){
      var spServicesList = specialServices && specialServices.PMSSpecialService;
      if(spServicesList && spServicesList.length) {
        var spServices = _.find(spServicesList, function (spService) {
          return spService.name === category;
        })
        gtag("event", "view_item_list", {
          item_list_id: "Room-Special-Services-" + category,
          item_list_name: "Room Special Services in" + category,
          items: _.map(spServices.val || [],
            function (service) {
              return {
                'item_id': service.PMSItemId,
                'sku': service.PMSSpecialServiceName,
                'item_name': service.PMSSpecialServiceName,
                'affiliation': app.localization.siteName,
                'item_category': service.PMSSpecialServiceName,
                'price': +service.Price,
                'quantity': 1
              };
            }
          ),
        });
      }
    },
    specialServiceItemClick: function (specialServices, itemId) {
      _.each(specialServices.PMSSpecialService, function (spService) {
         _.each(spService.val, function (service) {
            if(service.PMSItemId == itemId) {
              gtag("event", "view_item", {
                currency: app.customization.currencyCode,
                value: +service.Price,
                items: [
                  {
                    'item_id': service.PMSItemId,
                    'sku': service.PMSSpecialServiceName,
                    'item_name': service.PMSSpecialServiceName,
                    'affiliation': app.localization.siteName,
                    'item_category': service.PMSSpecialServiceName,
                    'price': +service.Price,
                    'quantity': 1
                  }
                ],
              });
            }
        });
      });
    }
  };
});

